<template>
  <div class="init" v-loading="loading">
    <div class="title">{{$vi18n('$i18n# 注册 #i18n$')}}</div>
    <div style="content_wrap">
      <loginstep class="step" :activity="step"></loginstep>
      <div class="content" >
        <div class="init_form" v-if="step == 1">
          <div class="init_form_title">{{ $vi18n("$i18n# 填写注册信息 #i18n$") }}</div>
          <el-form ref="form" label-width="180px" :rules="rules" :model="form">
            <el-form-item label=" UID" prop="uin">
              <el-input v-model="form.uin" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="Email" prop="email">
              <el-input v-model="form.email" :disabled="isEmail"></el-input>
            </el-form-item>
            <el-form-item :label="$vi18n('$i18n# 验证码 #i18n$')" prop="code">
              <el-input v-model="form.code">
                <template slot="append">
                  <el-button :class="{ code: true, uncode: !lock }" @click="getCode">{{
                    timer
                  }}</el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$vi18n('$i18n# 姓 #i18n$')" prop="last_name">
              <el-input v-model="form.last_name"></el-input>
            </el-form-item>
            <el-form-item :label="$vi18n('$i18n# 中间名 #i18n$')" prop="middle_name">
              <el-input v-model="form.middle_name" maxlength="16"></el-input>
            </el-form-item>
            <el-form-item :label="$vi18n('$i18n# 名 #i18n$')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$vi18n('$i18n# 国家 #i18n$')" prop="country_code">
              <el-select
                style="width: 300px"
                v-model="form.country_code"
                :placeholder="$vi18n('$i18n# 请选择国家 #i18n$')"
                filterable
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in langList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="form.is"
                ><el-link
                  type="primary"
                  target="_blank"
                  href="https://developers.miniworldgame.com/agreement"
                  >{{ $vi18n("$i18n# 同意并阅读迷你世界开发者协议 #i18n$") }}</el-link
                ></el-checkbox
              >
            </el-form-item>
            <el-form-item>
              <el-button type="warning" class="init_btn" @click="submit('form')">{{
                $vi18n("$i18n# 提交 #i18n$")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="info" v-if="step == 2">
          <h3>{{ $vi18n("$i18n# 填写收款信息 #i18n$") }}</h3>
          <div class="word">
            {{
              $vi18n(
                "$i18n# 恭喜你成功注册为开发者！为避免影响分成提现，请及时查阅提现详情说明（开发者中心->结算中心->右下角的详情说明）并且尽快完成支付信息的填写（开发者中心->支付信息）。 #i18n$"
              )
            }}
          </div>
          <el-button type="warning" class="info_btn" @click="ok(1)">OK</el-button>
        </div>

        <div class="finish" v-if="step == 3">
          <div class="icon"></div>
          <div class="word">
            {{ $vi18n("$i18n# 注册成功 #i18n$") }}<br />{{
              $vi18n("$i18n# 欢迎成为迷你开发者 #i18n$")
            }}
          </div>
          <div class="btn" @click="ok(2)">OK</div>
        </div>
      </div>
    </div>
    <Footer class="page_footer"></Footer>
  </div>
</template>

<script>
import loginstep from "../components/loginstep.vue";
import { $vi18n } from '@/utils/i18n.js';
import { getCode, registration, developJudgment } from '@/api/account.js';
import { mapState } from 'vuex';
import Footer from '@/layout/components/Footer.vue'
import countryList from '@/i18n/country.js'
import store from '@/store/index.js'
export default {
	name: 'registry',
	components: {
		loginstep,
    Footer
	},
  computed: {
     ...mapState(['userInfo', 'developerInfo']),
  },
	data() {
		return {
			form: {
				uin: "",
				email: "",
				code: "",
				is: false,
				last_name: "",
				middle_name: "",
				country_code: "",
				name: "",
			},
			lock: true,
			showForm: false,
			isEmail: false,
			timer: $vi18n('$i18n# 获取验证码 #i18n$'),
			rules: {
				email: [
        {
          required: true,
          message: $vi18n('$i18n# 请输入邮箱地址 #i18n$'),
          trigger: "blur",
        },
      ],
      code: [
        {
          required: true,
          message: $vi18n('$i18n# 请输入你收到的验证码 #i18n$'),
          trigger: "blur",
        },
      ],
      name: [
        {
          required: true,
          message: $vi18n('$i18n# 请输入您的名字 #i18n$'),
          trigger: "blur",
        },
      ],
      last_name: [
        {
          required: true,
          message: $vi18n('$i18n# 请输入您的姓氏 #i18n$'),
          trigger: "blur",
        },
      ],
      country_code: [
        {
          required: true,
          message: $vi18n('$i18n# 请选择国家 #i18n$'),
          trigger: "change",
        },
      ],
			},
			step: 1,
			langList: countryList,
      // [
			// 	{ lang: "简体中文", id: "0" },
			// 	{ lang: "English", id: "1" },
			// 	{ lang: "繁體中文", id: "2" },
			// 	{ lang: "ภาษาไทย", id: "3" },
			// 	{ lang: "Español", id: "4" },
			// 	{ lang: "Português", id: "5" },
			// 	{ lang: "Français", id: "6" },
			// 	{ lang: "日本語", id: "7" },
			// 	{ lang: "한국어", id: "9" },
			// 	{ lang: "Tiếng Việt", id: "10" },
			// 	{ lang: "Русский", id: "11" },
			// 	{ lang: "Türkçe", id: "12" },
			// 	{ lang: "Italiano", id: "13" },
			// 	{ lang: "Deutsch", id: "14" },
			// 	{ lang: "Bahasa Indonesia", id: "15" },
			// ],
			language: {},
			languageid: -1,
      loading: false
		}
	},
  created() {
    this.form.uin =
      process.env.NODE_ENV === "production"
        ? process.env.VUE_APP_REALEASE === "released"
          ? Number(this.userInfo.uin) - 1000000000 + ""
          : Number(this.userInfo.uin) + ""
        : Number(this.userInfo.uin) + "";
    this.getUserInfo();
  },
	methods: {
    ok(n) {
      if (n === 1) {
        this.step = 3;
      } else {
        sessionStorage.setItem("isdevelopJudgment", "true");
        this.$router.replace("/");
      }
    },
    async getUserInfo() {
      this.form.email = this.developerInfo.email
      this.isEmail = !!this.developerInfo.email
      // try {
      //   const data = await developJudgment({
      //     uin: this.userInfo.uin
      //   });
      //   if (data.email !== "") {
      //     this.isEmail = true;
      //     this.form.email = data.email;
      //   } else {
      //     this.isEmail = false;
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    },
		submit(form) {
			if (!this.form.is) {
				this.$message.error($vi18n('$i18n# 同意并阅读迷你世界开发者协议 #i18n$'));
				return;
			}
			const myfrom = this.$refs[form];
			myfrom.validate(async (valid) => {
				try {
          this.loading = true
					const res = await registration({
						uin: this.userInfo.uin,
						name: this.form.name,
						email: this.form.email,
						sms_code: this.form.code,
						language: this.languageid,
						last_name: this.form.last_name,
						middle_name: this.form.middle_name,
						country_code: this.form.country_code,
						from: "developer_web",
					});
          await store.dispatch('refreshDeveloperInfo')
					this.step = 2;
					sessionStorage.setItem("isdevelopJudgment", "true");
         
				} catch (error) {
					console.log(error);
				} finally {
           this.loading = false
        }
			});
		},
		async getCode() {
			if (!this.form.email) {
				this.$message.error($vi18n('$i18n# 请输入邮箱地址 #i18n$'));
				return;
			}
			if (this.lock) {
				try {
					const res = await getCode({
						uin: this.userInfo.uin,
						email: this.form.email,
					});
					this.$message({
						message:  $vi18n('$i18n# 验证码已发送至您的邮箱！ #i18n$'),
						type: "success",
					});
					this.lock = false;
					let time = 60;
					this.timer = time + "s";
					const Time = setInterval(() => {
						if (time === 0) {
							this.timer =  $vi18n('$i18n# 获取验证码 #i18n$');
							clearInterval(Time);
							this.lock = true;
						} else {
							time = time - 1;
							this.timer = time + "s";
						}
					}, 1000);
				} catch (error) {
					console.log(error);
				}
			} else {
				this.$message({
					message:  $vi18n('$i18n# 你的操作太频繁! #i18n$'),
					type: "warning",
				});
			}
		} 
	}
};

</script>

<style lang="scss" scoped>

.code {
  cursor: pointer;
  width: 110px;
  color: #fd9b21 !important;
}

.uncode {
  cursor: pointer;
  width: 110px;
  color: #bfbfbf !important;
}
.title {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  font-size: 24px;
  font-weight: 400;
  line-height: 60px;
  padding: 0 35px;
  color: rgba(38, 38, 38, 1);
}


.init {
  width: 100%;
  min-height: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  padding-bottom: 150px;
  position: relative;
  overflow: hidden;
  .finish {
    color: #666;
    .icon {
      width: 80px;
      height: 80px;
      background: url("../../../assets/images/ico_succeed.svg") no-repeat;
      background-size: 80px 80px;
      margin: auto;
      margin-top: 180px;
      margin-bottom: 24px;
    }

    .word {
      margin: auto;
      text-align: center;
      width: 300px;
      height: 61px;
      font-size: 16px;
      line-height: 20px;
      // color: rgba(129, 129, 143, 1);
    }

    .btn {
      margin: auto;
      width: 200px;
      height: 50px;
      background: rgba(253, 155, 33, 1);
      border-radius: 8px;
      font-size: 20px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      margin-top: 100px;
    }
  }

  .info {
    margin-top: 56px;
    display: flex;
    flex-direction: column;

    h3 {
      text-align: center;
      color: #333;
    }

    .word {
      width: 820px;
      height: 93px;
      font-size: 20px;
      line-height: 36px;
      color: #666;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 160px;
    }

    .info_btn {
      border-radius: 8px;
      background: rgba(253, 155, 33, 1);
      width: 200px;
      height: 50px;
      font-size: 20px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 200px;
    }
  }

  .step {
    margin: 29px 0 20px 0;
  }


  .init_form_title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-bottom: 40px;
  }

  .init_btn {
    position: relative;
    left: 50%;
    transform: translateX(-60%);
    border-radius: 8px;
    width: 200px;
  }

  .init_form {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-form {
      position: relative;
      left: -50px;
    }

    a {
      cursor: pointer;
      text-decoration: underline;
    }

    .el-input {
      width: 500px;
    }
  }
}
.page_footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
